import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BehaviourSubjectService {

  public isLoggedIn: BehaviorSubject<boolean>;
  public freeSearchTokenUpdated = new BehaviorSubject<any>(null);
  public refreshTokenSubject = new BehaviorSubject<any>(null)
  public userLoggedOut = new BehaviorSubject<any>(false);
  public userLoggedIn = new BehaviorSubject<any>(false);
  private searchTermSubject = new BehaviorSubject<string>('');
   public isSmart=new BehaviorSubject<boolean>(false);
 
  private loginSourceSubject = new BehaviorSubject<'buy_now' | 'other' | null>(null);
  private productDataSubject = new BehaviorSubject<any>(null);
  private showLoginModalSubject = new BehaviorSubject<boolean>(false);
  private selectedFiltersSubject = new BehaviorSubject<any>({});
  private categoryChangedSubject = new BehaviorSubject<any>(null);
  constructor() {
    this.isLoggedIn = new BehaviorSubject<boolean>(false);
    this.freeSearchTokenUpdated = new BehaviorSubject<any>(null);
    this.refreshTokenSubject = new BehaviorSubject<any>(null);
    this.userLoggedOut = new BehaviorSubject<boolean>(false);
    this.userLoggedIn = new BehaviorSubject<boolean>(false);
   
  }

  showLoginModal$ = this.showLoginModalSubject.asObservable();

  loginSource$ = this.loginSourceSubject.asObservable();

  productData$ = this.productDataSubject.asObservable();
  searchTerm$ = this.searchTermSubject.asObservable();
  selectedFilters$ = this.selectedFiltersSubject.asObservable();
  categoryChanged$ = this.categoryChangedSubject.asObservable();

  setSelectedFilters(data: any) {
    this.selectedFiltersSubject.next(data);
  }

  getSelectedFilters(): any {
    return this.selectedFiltersSubject.getValue();
  }

  clearSelectedFilters() {
  this.selectedFiltersSubject.next(null); // Or an empty object: {}
}

  openLoginModal(source: 'buy_now' | 'other' = 'other', data: any = null) {
    this.loginSourceSubject.next(source);
    this.productDataSubject.next(data);
    this.showLoginModalSubject.next(true);
  }

  closeLoginModal() {
    this.loginSourceSubject.next(null);
    this.productDataSubject.next(null);
    this.showLoginModalSubject.next(false);
  }


  setSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }

  setCategoryChanged(data: any) {
    this.categoryChangedSubject.next(data);
  }

  clearCategoryChanged() {
    this.categoryChangedSubject.next(null);
  }

}
